module.exports = __webpack_public_path__ + "img/logo2.152d7c54.png";